import { FC } from 'react';
import { Link } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'jbc-front/components/Button';
import { SearchResult } from 'jbc-front/components/SearchForm';
import { yup } from '@/libs/yup';
import { SortingFields } from '@/components/SearchForm/SortingFields';
import { useDisplayEmployeeLimit } from '@/components/utils/display_employee_limit';
import { useDebouncedSubmit } from '@/hooks/useDebouncedSubmit';
import styles from './SearchForm.scss';

const IGNORE_AUTO_SUBMIT_FIELDS = ['limit', 'sortType'];

const limits = ['10', '20', '50', '100'].map(ele => ({ value: ele, label: `${ele}件を表示` }));

const sortTypes = [];

const mainFieldSchema = yup.object({});

const additionalFieldSchema = yup.object({});

const sortTypeSchema = yup.object({});

const paginatorSchema = yup.object({
  page: yup.string(),
  limit: yup.string()
});

const schema = mainFieldSchema.concat(additionalFieldSchema).concat(sortTypeSchema).concat(paginatorSchema);

export type Schema = yup.InferType<typeof schema>;

interface SearchFormProps {
  values: Schema;
  totalCount?: number;
  isLoading: boolean;
  onSubmit: (data: Schema) => void;
  onClear: () => void;
  hasConditions: (data: Schema) => boolean;
}

export const SearchForm: FC<SearchFormProps> = ({ values, totalCount, isLoading, onSubmit }) => {
  const [limit, setLimit] = useDisplayEmployeeLimit();
  const methods = useForm<Schema>({
    values,
    resolver: yupResolver(schema)
  });
  const { handleSubmit, watch, subscribe } = methods;

  const formValues = watch();
  const { page } = formValues;

  useDebouncedSubmit(subscribe, () => handleSubmit(onSubmit)(), {
    ignoreAutoSubmitFields: IGNORE_AUTO_SUBMIT_FIELDS
  });

  return (
    <FormProvider {...methods}>
      <div className={styles.searchForm}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.result}>
            <div className={styles.resultButtonContainer}>
              <Button as={Link} to="/regular_health_checkup/reports/create" widthAuto primary>
                新規作成
              </Button>
            </div>
            <SearchResult
              className={styles.resultCenter}
              total={totalCount}
              page={page}
              limit={limit}
              isLoading={isLoading}
              failureMessage=""
            />
            <SortingFields
              limits={limits}
              onChangeLimit={newValue => {
                setLimit(newValue);
                handleSubmit(onSubmit)();
              }}
              sortTypes={sortTypes}
              onChangeSortType={() => handleSubmit(onSubmit)()}
            />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};
